module.exports = __webpack_public_path__ + "img/icon-close-black.5da547bd.svg";